import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useCurrentWorkspaceId } from '@/entities/workspace';
import { notificationService } from '@/lib/services/notification.service';
import {
  upsertSpringboardCategories,
  type SpringboardCategoryItemDto,
} from '../api/springboard-categories.api';
import { SPRINGBOARD_CATEGORIES_QUERY_KEYS } from '@/shared/constants/springboard-categories-query-keys';
import { useTranslation } from 'react-i18next';

export const useSaveSpringboardCategories = () => {
  const { t } = useTranslation('springboard');

  const queryClient = useQueryClient();
  const workspaceId = useCurrentWorkspaceId() ?? '';

  return useMutation({
    mutationFn: (categories: SpringboardCategoryItemDto[]) =>
      upsertSpringboardCategories(workspaceId, categories),
    onSuccess: (data) => {
      // The upsert response is the authoritative saved state, so seed the cache
      // directly. No invalidate/refetch — it would only re-request what we just
      // wrote (and this key has no other consumers).
      queryClient.setQueryData(SPRINGBOARD_CATEGORIES_QUERY_KEYS.categories(workspaceId), data);
    },
    onError: () => {
      notificationService.showError(
        t('springboard.useSaveSpringboardCategories.couldNotSaveCustomization'),
      );
    },
  });
};
